export default __webpack_public_path__ + "static/media/clock-gray.a722af98.svg";